export default "__VITE_ASSET__CKb1916___"